export enum TIME_FREQUENCY {
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  NONE = 'None',
  YEALY = 'Yearly',
}

export interface IEventSeries {
  eventGroupId?: string;
  dailyStartTime: string;
  dailyEndTime: string;
  startDate: string;
  endDate: string;
  eventDuration: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  resourceIds: string[];
  id?: string;
  providerId: string;
  deleted: boolean;
  frequency: TIME_FREQUENCY;
  byMonthDay: number | null;
  bySetPos: number | null;
  byMonth: number | null;
}
